angular
	.module('inputCdDestinatario.components', [])
	.component('inputCdDestinatario', {
		templateUrl: 'ng/components/inputCdDestinatario/inputCdDestinatario.html',
		bindings: {
			/** Input data **/
			inputId: '@',
			inputName: '@',
			inputClass: '@',
			formName: '=',
			bindingVariable: '=',
			/** Optional data **/
			inputDisableOn: '<',
			inputRequired: '<',
			onChange: '&?'
		},
		controllerAs: 'inputCdDestinatarioCtrl',
		controller: function ($scope, $translate, validationService) {

			/** not to loose *this reference **/
			var self = this;

			self.validationService = validationService;

			self.$onInit = function () {
				console.log(self);
				self.inputDisableOn = self.inputDisableOn || false;

				//Quando viene costruito, check immediato sulla validità
				self.bindingVariable && self.checkCdDestinatario(self.bindingVariable);
			}

			self.$onChanges = function (changesObj) {}

			self.errorMsgShown = false;

			self.resetAlert = function () {
				self.errorMsgShown = false;
			}

			self.showAlertMsg = function () {
				self.errorMsgShown = !self.errorMsgShown;
			}

			self.checkCdDestinatario = function (cdDestinatario) {
				if (typeof (cdDestinatario) == 'undefined') {
					self.formName[self.inputName] &&
						self.formName[self.inputName].$setValidity('cdDestinatario', false);
					return;
				}

				if (cdDestinatario == '') {
					if (self.inputRequired) {
						self.formName[self.inputName].$setValidity('cdDestinatario', false);
						return;
					} else {
						self.formName[self.inputName].$setValidity('cdDestinatario', true);
					}

				}

				if (!validationService.isValidCdDestinatario(cdDestinatario)) {
					self.formName[self.inputName].$setValidity('cdDestinatario', false);
					self.onChange && self.onChange({
						value: cdDestinatario
					});
					return;
				}

				//here the field is valid, return false before this point if you got here
				self.formName &&
					self.inputName &&
					self.formName[self.inputName] &&
					self.formName[self.inputName].$setValidity('cdDestinatario', true);
				self.onChange && self.onChange({
					value: cdDestinatario
				});

			}


		}
	});